export const SHOW_LOADER = 'SHOW_LOADER';